import React, { useState } from "react";

function CustomTabsDashboard({ tabsTitleArray, tabsContentObject }) {
  const [activeTab, setActiveTab] = useState(tabsTitleArray[0]);

  const handleTabSuper = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <>
      <div className="tab-list overflow-x-auto flex gap-2 w-full ">
        {tabsTitleArray.map((tab, i) => (
          <div
            onClick={() => handleTabSuper(tab)}
            key={i + 100}
            className={`${
              activeTab === tab
                ? "text-primary bg-primary bg-opacity-10 "
                : "text-textS"
            } px-4 rounded-md flex whitespace-nowrap justify-center items-center h-[30px] focus:bg-primary focus:text-primary focus:bg-opacity-10 hover:bg-primary hover:bg-opacity-10 cursor-pointer font-semibold text-[12px] leading-3`}
          >
            {tab}
          </div>
        ))}
      </div>

      <div className="outlet">
        {Object.keys(tabsContentObject).map((key, i) => {
          if (tabsTitleArray.includes(key)) {
            return (
              <div key={i + 2}>
                {activeTab === key ? (
                  <div>
                    <div className="h-[340px] overflow-y-auto">
                      {tabsContentObject[key]}
                    </div>
                  </div>
                ) : null}
              </div>
            );
          }
          return null;
        })}
      </div>
    </>
  );
}

export default CustomTabsDashboard;
